import React from 'react';
import { useEditDrawerState, useTableDataSource } from '@/helpers/hooks';
import { Store } from 'antd/lib/form/interface';
import { useCreateCategoryApi, useUpdateCategoryApi } from '@/api/brand';
import { Category, CreateCategoryRequest } from '@/typings/entity/category';
import { Link } from 'react-router-dom';

export function useCategoryListHelper(brandId: number) {
  const editDrawer = useEditDrawerState<Category>('id', [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => (a.name > b.name ? 1 : -1),
      render: (_: string, record: Category) => (
        <Link to={`/brands/${brandId}/categories/${record.id}/items`}>{record.name}</Link>
      ),
    },
  ]);
  const dataSource = useTableDataSource<Category>();

  const createApi = useCreateCategoryApi();
  const updateApi = useUpdateCategoryApi();
  const onSubmit = (values: Store) => {
    const { name, priority } = values;
    const payload: CreateCategoryRequest | Category = {
      name,
      priority: parseInt(priority, 10),
      brandId,
    };
    if (editDrawer.mode === 'create') {
      createApi(payload).then((res) => {
        dataSource.push(res);
        editDrawer.close();
      });
    } else {
      // edit
      const next = {
        ...payload,
        id: editDrawer.identifier as number,
      };
      updateApi(next).then(() => {
        dataSource.replace('id', next);
        editDrawer.close();
      });
    }
  };

  return {
    dataSource,
    onSubmit,
    editDrawer,
  };
}
